import { render, staticRenderFns } from "./downcount.vue?vue&type=template&id=ed57b116"
import script from "./downcount.vue?vue&type=script&lang=js"
export * from "./downcount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports